import mondaySdk from "monday-sdk-js";
import useSWR from "swr";
import { getBoardHierarchyTypeQl } from "../../services/monday/monday-queries";
import useBoardAndItems from "../context/useBoardAndItems";
import { MONDAY_API_VERSION } from "../../services/monday/monday-api-version";

const monday = mondaySdk();

const fetchBoardHierarchyType = async (boardId: number): Promise<string | null> => {
  const result = await monday.api(getBoardHierarchyTypeQl(boardId), {
    apiVersion: MONDAY_API_VERSION,
  });
  return (result as any)?.data?.boards?.[0]?.hierarchy_type ?? null;
};

export const useOriginBoardHierarchyType = (): {
  hierarchyType: string | null;
  isLoading: boolean;
} => {
  const { currentBoard } = useBoardAndItems();
  const { data, isLoading } = useSWR(
    currentBoard ? `origin-board-hierarchy-type:${currentBoard}` : null,
    () => fetchBoardHierarchyType(currentBoard!),
    { revalidateOnFocus: false },
  );
  // SWR's own flag only: an errored or null lookup must not leave the list spinning forever.
  return { hierarchyType: data ?? null, isLoading };
};
